import React from 'react';

import { TooltipPortal } from '~components';

interface ComponentProps {
  id: string;
  references: string[];
}

const ReferenceTooltips: React.FC<ComponentProps> = ({ id, references = [] }) => {
  return (
    <div className="d-flex flex-wrap gap-2">
      <span id={`reference-count-${id}`} className="unstyled-button">
        {references.length}
      </span>
      <TooltipPortal targetId={`reference-count-${id}`} content={references.join(', ')} />
    </div>
  );
};

export default ReferenceTooltips;
